import React, { useEffect } from 'react'
import aos from "aos"
import "aos/dist/aos.css"

const Featuredproject = () => {
  useEffect(()=>{
    aos.init({duration:3000});
    });

  return (
    <section className="portfolio-area page-section scroll-to-page" style={{padding: "30px 0px",paddingBottom:"40px"}} id="portfolio">
    <div className="custom-container">
      <div className="portfolio-content content-width">
        <div className="section-header">
          <h4 className="subtitle scroll-animation" data-animation="fade_from_bottom">
            <i className="las la-grip-vertical" /> portfolio
          </h4>
          <h1 className="scroll-animation" data-aos="fade-up"
     data-aos-anchor-placement="top-bottom" data-animation="fade_from_bottom" >Featured <span>Projects</span></h1>
        </div>
        <div className="row portfolio-items">
          <div className="col-md-12 scroll-animation" data-animation="fade_from_bottom">
            <div className="portfolio-item portfolio-full">
              <div className="portfolio-item-inner">
                <a href="assets/images/ay.png" data-lightbox="example-3">
                  <img src="assets/images/ay.png" alt="Portfolio" />
                </a>
                <a href="assets/images/home.png" data-lightbox="example-3"></a>
                <a href="assets/images/blog.png" data-lightbox="example-3"></a>
                <a href="assets/images/About-Us.png" data-lightbox="example-3"></a>
                <ul className="portfolio-categories">
                  <li>
                    <a href="#">React.js</a>
                  </li>
                  <li>
                    <a href="#">Codeigniter</a>
                  </li>
                  <li>
                    <a href="#">Mysql</a>
                  </li>
                  <li>
                    <a href="#">Php</a>
                  </li>
                </ul>
              </div>
              <h2><a href="#">Ayur Herbals</a></h2>
            </div>
          </div>
          {/* <div className="col-md-6 scroll-animation" data-animation="fade_from_left">
            <div className="portfolio-item portfolio-half">
              <div className="portfolio-item-inner">
                <a href="assets/images/portfolio2.jpg" data-lightbox="example-1">
                  <img src="assets/images/portfolio2.jpg" alt="Portfolio" />
                </a>
                <img src="assets/images/portfolio2.jpg" alt="Portfolio" />
                <ul className="portfolio-categories">
                  <li>
                    <a href="#">WordPress</a>
                  </li>
                  <li>
                    <a href="#">Larevel/PHP</a>
                  </li>
                </ul>
              </div>
              <h2><a href="#">Moonex WordPress Theme</a></h2>
            </div>
          </div>
          <div className="col-md-6 scroll-animation" data-animation="fade_from_right">
            <div className="portfolio-item portfolio-half">
              <div className="portfolio-item-inner">
                <a href="assets/images/portfolio3.jpg" data-lightbox="example-1">
                  <img src="assets/images/portfolio3.jpg" alt="Portfolio" />
                </a>
                <ul className="portfolio-categories">
                  <li>
                    <a href="#">Figma</a>
                  </li>
                  <li>
                    <a href="#">Webflow</a>
                  </li>
                </ul>
              </div>
              <h2><a href="#">Taskly Dashboard</a></h2>
            </div>
          </div> */}
          <div className="col-md-12 scroll-animation" data-animation="fade_from_bottom">
            <div className="portfolio-item portfolio-half">
              <div className="portfolio-item-inner">
                <a href="assets/images/ky.png" data-lightbox="example-4">
                  <img src="assets/images/ky.png" alt="Portfolio" />
                </a>
                <a href="assets/images/KYCfirst.png" data-lightbox="example-4"></a>
                <a href="assets/images/KYCfirs.png" data-lightbox="example-4"></a>
                <ul className="portfolio-categories">
                  <li>
                    <a href="#">React.js</a>
                  </li>
                  <li>
                    <a href="#">Python</a>
                  </li>
                  <li>
                    <a href="#">MYSQL</a>
                  </li>
                </ul>
              </div>
              <h2><a href="#">KycFirst</a></h2>
            </div>
          </div>
          <div className="col-md-12 scroll-animation" data-animation="fade_from_bottom">
            <div className="portfolio-item portfolio-half">
              <div className="portfolio-item-inner">
                <a href="assets/images/hd.png" data-lightbox="example-1">
                  <img src="assets/images/hd.png" alt="Portfolio" />
                </a>
                <a href="assets/images/hdw.png" data-lightbox="example-1"></a>
                <a href="assets/images/hdw2.png" data-lightbox="example-1"></a>
                <ul className="portfolio-categories">
                  <li>
                    <a href="#">Framer</a>
                  </li>
                </ul>
              </div>
              <h2><a href="#">Hardwyn</a></h2>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  )
}

export default Featuredproject